import React, { useEffect, useRef, useState } from "react";

import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Typography,
} from "antd";
import LogoBackground from "assets/images/diary-bg-img.jpg";
import Logo from "assets/images/logo.svg";
import User from "models/user/user";
import qs from "qs";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  deleteQueryParam,
  downloadEvent,
  setFieldErrorsFromServer,
} from "utilities/generalUtility";
import { onlyAlphabets, shortPasswordRegex } from "utilities/regexUtilities";
import UserVerificationModal from "./userVerificationModal";
import GoogleLogin from "utilities/googleLogin";
import { ExclamationCircleFilled } from "@ant-design/icons";
import TermsAndConditionModal from "./termsAndConditionModal";

export default function Register() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState({ status: false, message: "" });
  const [checked, setChecked] = useState(false);
  const inputRef = useRef(null);
  const [genderName, setGenderName] = useState("");
  const [dropdownOpener, setdropdownOpener] = useState(false);

  const [genderOptions, setGenderOptions] = useState([
    {
      value: "Male",
    },
    {
      value: "Female",
    },
    {
      value: "Non-binary",
    },
    {
      value: "Genderqueer",
    },
    {
      value: "Transgender",
    },
    {
      value: "Prefer not to say",
    },
  ]);

  const onCheckboxChange = async (e) => {
    await setChecked(e.target.checked);
    form.validateFields(["checkbox"]);
  };

  const onGenderNameChange = (event) => {
    setGenderName(event.target.value);
  };

  const validation = (rule, value, callback) => {
    if (checked) {
      return callback();
    }
    return callback("Please accept the terms and conditions");
  };
  const email = useRef();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const dispatch = useDispatch();
  const location = useLocation();
  const [form] = Form.useForm();
  const [form1] = Form.useForm();

  const paramJson = qs.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    inputRef?.current && inputRef?.current?.focus();
    if (paramJson.err) {
      message.error(paramJson.err);
      deleteQueryParam("err");
    }
    paramJson?.Email &&
      form.setFieldsValue({
        firstName: paramJson?.FirstName && paramJson?.FirstName,
        lastName: paramJson?.LastName && paramJson?.LastName,
        email: paramJson?.Email.replace(/ /g, "+"),
      });
  }, []);

  const onFinish = async (values) => {
    email.current = values.email;
    values.roleType = 2;
    // if (values.password !== values.confirmPassword) {
    //   message.error("Password does not match!");
    //   return;
    // }
    try {
      const registeredUser = await dispatch(User.Register(values));
      setIsError((prev) => {
        return {
          ...prev,
          status: false,
          message: "",
        };
      });
      registeredUser && showModal();

      // redirectToUrl("/");
    } catch (error) {
      setIsError((prev) => {
        return {
          ...prev,
          status: true,
          message: error.message,
        };
      });
      error?.statusCode === 403 && showModal();
      setFieldErrorsFromServer(error, form, values);
    }
  };

  const addGender = (values) => {
    setGenderOptions([...genderOptions, { value: values?.genderInput }]);
    form.setFieldsValue({ gender: values?.genderInput });
    form1.setFieldsValue({ genderInput: null });
    setdropdownOpener(false);
  };

  const { Title } = Typography;

  return (
    <React.Fragment>
      <div className="login-container d-flex">
        <div className="login-bg w-100">
          <img className="login-img w-100 h-100" src={LogoBackground} alt="" />
        </div>
        <Card bordered={false} className="login-card">
          <div className="authentication-logo text-center">
            <img className="logo" src={Logo} alt="" />
          </div>
          <Title level={4}>Sign Up</Title>
          {isError.status && (
            <Alert
              className="custom-alert"
              description={isError.message}
              // description={
              //   <p className="mb-0">
              //     Let’s create a new account for{" "}
              //     <strong> example.example@example.com</strong>
              //   </p>
              // }
              showIcon
              icon={<ExclamationCircleFilled />}
            />
          )}
          <Form
            className="create-diary-form"
            form={form}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
          >
            {/* <UserRoleType form={form} /> */}
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your first name!",
                    },
                    {
                      pattern: new RegExp(onlyAlphabets),
                      message:
                        "Field does not accept numbers,special chracters or spaces",
                    },
                  ]}
                >
                  <Input
                    ref={inputRef}
                    type="name"
                    maxLength={25}
                    suffix={<i className="icon-user site-form-item-icon"></i>}
                    placeholder="First name"
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your last name!",
                    },
                    {
                      pattern: new RegExp(onlyAlphabets),
                      message:
                        "Field does not accept numbers,special chracters or spaces",
                    },
                  ]}
                >
                  <Input
                    type="name"
                    maxLength={25}
                    suffix={<i className="icon-user site-form-item-icon"></i>}
                    placeholder="Last name"
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              name="gender"
              rules={[
                {
                  required: true,
                  message: "Please select Your Gender!",
                },
              ]}
            >
              <Select
                popupClassName="relationship-select-dropdown"
                getPopupContainer={(triggerNode) => {
                  return triggerNode.parentNode;
                }}
                className="relationship-select"
                suffixIcon={
                  <i className="icon-arrow-down site-form-item-icon text-primary"></i>
                }
                size="large"
                placeholder="Select Gender"
                options={genderOptions}
                onFocus={() => {
                  setdropdownOpener(true);
                }}
                open={dropdownOpener}
                onDropdownVisibleChange={(op) => {
                  setdropdownOpener(op);
                }}
                dropdownRender={(menu) => (
                  <>
                    {menu}{" "}
                    <Form
                      layout="horizontal"
                      form={form1}
                      onFinish={addGender}
                      className="rel-dropdown"
                    >
                      <Form.Item
                        label="Other"
                        name="genderInput"
                        className="relationship-name"
                        rules={[
                          {
                            required: true,
                            message: "Gender name is required",
                          },
                          {
                            min: 3,
                            message: "Gender must have 3 characters",
                          },
                          {
                            max: 15,
                            message: "Gender must be less than 15",
                          },
                        ]}
                      >
                        <Input
                          onClick={(e) => e.stopPropagation()}
                          placeholder="Add Gender"
                          value={genderName}
                          onChange={onGenderNameChange}
                        />
                      </Form.Item>

                      <Form.Item className="mb-0 text-right">
                        <Button
                          key="add"
                          type="primary"
                          htmlType="submit"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          Add
                        </Button>
                      </Form.Item>
                    </Form>
                  </>
                )}
              />
            </Form.Item>
            {/* <Form.Item
              name="phoneNumber"
              rules={[
                // {
                //   required: true,
                //   message: "Please enter phone number",
                // },
                {
                  whitespace: true,
                  message: "Only Spaces are not allowed",
                },

                {
                  pattern: new RegExp(phoneRegex),
                  message: "Please Enter Valid Phone Number",
                },
              ]}
            >
              <PatternFormat
                placeholder="Enter Mobile Number"
                customInput={Input}
                format={"###########"}
                className="mbile-number-field"
              />
            </Form.Item> */}
            <Form.Item
              name="email"
              hasFeedback
              rules={[
                {
                  type: "email",
                  message: "The Input is not valid Email",
                },
                {
                  required: true,
                  message: "Please input your Email!",
                },
              ]}
            >
              <Input
                type="email"
                suffix={<i className="icon-email site-form-item-icon"></i>}
                placeholder="Email"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="password"
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },

                {
                  whitespace: true,
                  message: "All spaces are not allowed",
                },
                {
                  pattern: new RegExp(shortPasswordRegex),
                  message:
                    "Password must be at least 8 characters and contain one digit or a special character",
                },
              ]}
            >
              <Input.Password
                placeholder="Password"
                size="large"
                autoComplete="false"
              />
            </Form.Item>
            {/* <Form.Item
              name="confirmPassword"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input your confirm password!",
                },
                {
                  whitespace: true,
                  message: "All spaces are not allowed",
                },
                {
                  pattern: new RegExp(passwordRegex),
                  message: passwordMessage,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Confirm password"
                size="large"
                autoComplete="false"
              />
            </Form.Item> */}

            <Form.Item>
              <GoogleLogin form={form} />
            </Form.Item>
            <Form.Item>
              <Button
                block
                size="large"
                type="primary"
                htmlType="submit"
                onClick={() => {
                  downloadEvent("SignUp");
                }}
              >
                Sign Up
              </Button>
            </Form.Item>
            <Form.Item name="checkbox" rules={[{ validator: validation }]}>
              <Checkbox
                className="terms-condition-checkbox"
                checked={checked}
                onChange={onCheckboxChange}
              >
                By clicking Sign Up, continue with Google, you agree our{" "}
                {/* <Link>Terms and Conditions</Link> */}
                <TermsAndConditionModal />
              </Checkbox>
            </Form.Item>
            {/* <Form.Item className="mb-0">
              <Button
                block
                className="google-account-btn"
                size="large"
                icon={<Image preview={false} src={GoogleLogo} alt="" />}
              >
                Login with Google Account
              </Button>
            </Form.Item> */}

            <Title level={5} className="text-center">
              Have an Account? <Link to="/login"> Login</Link>
            </Title>
          </Form>
        </Card>
      </div>
      <UserVerificationModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        email={email?.current}
      />
    </React.Fragment>
  );
}
